import React from "react";
import _ from "lodash";
import { ReactComponent as ChevronRight } from "../../Assets/Icons/chevron-right.svg";
import CTAButton from "../CTABtnWrapper";
import Image from "../Image";
import useTranslationEncapsulated from "../../Libs/useTranslation";
import "./index.scss";

export default function FeatureMasonry({ data, pageName }) {
  const { getTranslatableContent } = useTranslationEncapsulated();

  return (
    <section className="product-feature-masonry-bg js-section_nav-dark">
      <div className="container mx-auto product-feature-masonry__container">
        <div className="product-feature-masonry__title-wrapper">
          <div
            className="product-feature-masonry__title"
            dangerouslySetInnerHTML={{
              __html: getTranslatableContent(data?.title),
            }}
          />
        </div>
        <div className="product-feature-masonry__wrapper">
          <div className="product-feature-masonry__inner">
            {data?.featureList.map((f, i) => (
              <div
                key={i}
                className={`product-feature-masonry__card product-feature-masonry__card--column-${f.column}  product-feature-masonry__card--row-${f.row} product-feature-masonry__card--${f.style}`}
              >
                <div className="product-feature-masonry__card-wrapper">
                  <div className="product-feature-masonry__card">
                    <div
                      className={`product-feature-masonry__card-content product-feature-masonry__card-content--${
                        f.image ? "" : "no-image"
                      }`}
                    >
                      <div className="product-feature-masonry__card-content__info">
                        <div className="product-feature-masonry__card-title">
                          {getTranslatableContent(f.title)}
                        </div>
                        <div className="product-feature-masonry__card-desc">
                          {getTranslatableContent(f.description)}
                        </div>
                      </div>
                      {f.image ? (
                        <div className="product-feature-masonry__card-image">
                          <Image
                            fileName={f.image.source}
                            width={f.image.width}
                            height={f.image.height}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="product-feature-masonry__link-wrapper">
          {data.cta.map((c, i) => (
            <CTAButton
              id={c.id}
              key={c.id}
              options={{
                formPopupTheme: "light",
                utmLabel: "js_try_all_features_14_days_btn",
              }}
              children={
                <button
                  id={c.id}
                  key={c.id + "_children"}
                  className="product-feature-masonry__link"
                >
                  <span className="product-feature-masonry__link-desc">
                    {getTranslatableContent(c?.label)}
                  </span>
                  <span className="product-feature-masonry__link-icon">
                    <ChevronRight />
                  </span>
                </button>
              }
              data={{ ...c, ...{ pageName: getTranslatableContent(pageName) } }}
            ></CTAButton>
          ))}
        </div>
      </div>
    </section>
  );
}
